<template>
  <div class="zero-results">
    <div class="tw-mb-10">
      <div class="zero-results__image tw-w-52">
        <slot></slot>
      </div>
    </div>
    <div class="zero-results__message-container">
      <h2
        class="zero-results__heading-message"
        data-testid="page-heading"
      >
        <span v-html="headingMessage"></span>
      </h2>
      <h3 class="zero-results__secondary-message">
        <span v-html="secondaryMessage"></span>
      </h3>
    </div>
    <AcvButton
      v-if="action.length"
      :outlined="true"
      class="zero-results__button"
      data-testid="error-cta"
      @click.stop="emit('actionClicked')"
    >
      {{ action }}
    </AcvButton>
  </div>
</template>

<script setup>
const props = defineProps({
  headingMessage: {
    type: String,
    default: "We didn't find any exact matches",
  },
  secondaryMessage: {
    type: String,
    default: 'Jobs are constantly being added to our Loadboard.  Change filters and search again!',
  },
  action: {
    type: String,
    default: 'Clear All Filters',
  },
});

const emit = defineEmits(['actionClicked']);
</script>

<style lang="scss" scoped>
@use '@/assets/scss/search/buttons.scss';
.zero-results {
  @apply tw-flex tw-h-svh tw-flex-col tw-items-center tw-justify-center tw-p-4 tw-text-center tw-text-text-secondary;
}
.zero-results__image {
  max-width: 200px;
  max-height: 200px;
}

.zero-results__message-container {
  max-width: 375px;
}
.zero-results__heading-message {
  @apply tw-mb-2 tw-text-xl tw-font-medium;
}
.zero-results__secondary-message {
  @apply tw-mb-7 tw-text-base tw-font-regular;
}
.zero-results__button {
  min-width: 201px;
}
</style>
